<template>
  <div class="vedio-box">
    <div style="position:relative">
      <img src="./img/map1.png" class="img" @click="changeTab">
      <el-select filterable  @change="selectDeviceSerial($event)" v-model="deviceSerialSelect" style="float: right" v-if="showFlg">
        <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in deviceSerialList"></el-option>
      </el-select>
      <el-tag style="float: right" v-if="showFlg">{{$t("deviceList")}}</el-tag>
    </div>

    <div id="video-container" class="vedio" v-if="showFlg">
      <!--      <iframe-->
      <!--        :src=src-->
      <!--        id="ysOpenDevice"-->
      <!--        template="theme"-->
      <!--        allowfullscreen-->
      <!--        autoplay="true"-->
      <!--        frameborder="0"-->
      <!--        class="iframe"-->
      <!--        v-if="showFlg"-->
      <!--      >-->
      <!--      </iframe>-->
    </div>
  </div>
</template>

<script>
  import EZUIKit from 'ezuikit-js'
  import axios from "axios";
  import {getAttributesShared} from "../untils/api/home";
  export default {
    name: "centerVedio",
    components: {
      EZUIKit,
      axios
    },
    data () {
      return {
        player: null,
        accessToken: '',
        newURL:'',
        src: '',
        appKey: '',
        secret: '',
        defaultDevice:'',
        showFlg: false,
        address:[],
        deviceSerialSelect: '',
        deviceSerialList: [],
        windowHeight: document.documentElement.clientHeight,
        windowWidth: document.documentElement.clientWidth,
        appKeyStr: '',
        channelNo: 1,
        time: null,
      }
    },

    methods:{

      /**
       * 根据设备获取 appKey secret deviceSerial
       * @param deviceId
       */
      getSelectDevice(deviceId){
        //初期化清空
        this.appKey = '';
        this.secret = '';
        this.address = [];
        this.deviceSerialList = [];
        this.defaultDevice = '';
        this.deviceSerialSelect = '';
        let num = 0;
        // deviceFlg === false ? console.log("不清空") : document.getElementById('video-container').innerHTML = "";

        //访问api
        getAttributesShared(deviceId.entityType, deviceId.id).then(response => {
          for(let i = 0; i < response.length; i++){
            if(response[i].key.toString().indexOf('vedio') !== -1){
              let json = JSON.parse(response[i].value);
              let deviceSerialJson = {};
              deviceSerialJson.id = num; //设备id
              deviceSerialJson.name = json.deviceSerial;//设备名
              this.deviceSerialSelect = num;//选中设备id
              this.address.push(json);//监控信息
              this.appKey = json.appKey;
              this.secret = json.secret;
              this.channelNo = 1;
              if(json.deviceSerial.indexOf('-') !== -1) {
                this.defaultDevice = json.deviceSerial.split("-")[0];
                this.channelNo = json.deviceSerial.split("-")[1];
              } else {
                this.defaultDevice = json.deviceSerial;//选中的设备
              }
              this.deviceSerialList.push(deviceSerialJson);//设备列表
              num++;
            }
          }
          //appKey secret deviceSerial 均存在
          if(this.appKey !== '' && this.secret !== '' && this.defaultDevice !== ''){
            this.showFlg = true;
            this.setVedio();
          } else {
            //appKey secret deviceSerial 均不存在
            this.showFlg = false;
          }
          this.appKeyStr = this.appKey;
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 根据选中的设备获取url
       * @param event
       */
      selectDeviceSerial(event){
        this.appKey = this.address[event].appKey;//appley
        this.secret = this.address[event].secret;//secret
        let deviceNum = this.address[event].deviceSerial;//选中设备名称
        this.channelNo = 1;
        if(deviceNum.indexOf('-') !== -1) {
          this.defaultDevice = deviceNum.split("-")[0];
          this.channelNo = deviceNum.split("-")[1];
        } else {
          this.defaultDevice = deviceNum;//选中的设备
        }
        this.deviceSerialSelect = event;//选中设备id
        this.setVedio();
      },

      /**
       * 获取ccesstoken url
       */
      setVedio(){
        Promise.all([
          //获取accesstoken
          this.getAccessToken(),
        ]).then(res => {
          Promise.all([
            //获取url
            this.getURL()
          ]).then(res => {

            this.src = '';
            // this.src = 'https://open.ys7.com/ezopen/h5/iframe?url=' + this.newURL + '&autoplay=1&accessToken=' + this.accessToken;
            console.log("src",this.src)
            clearInterval(this.time);
            this.time = null;
            this.setPlayVedio();
            this.time = window.setInterval(() => {
              setTimeout(() => {
                this.setPlayVedio();
              }, 0)
            }, 1000 * 60 * 10);
          })
        })
      },

      setPlayVedio(){
        document.getElementById('video-container').innerHTML = "";
        this.player = null;

        if(this.channelNo == 1) {
          this.player = new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: "video-container", // 视频容器ID
            accessToken: this.accessToken,
            url: this.newURL,
            template: 'theme',//simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
            width:this.windowWidth * 0.45,
            height:this.windowHeight * 0.47,
          })
        } else {
          this.player = new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: "video-container", // 视频容器ID
            accessToken: this.accessToken,
            url: this.newURL,
            template: 'simple',//simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
            width:this.windowWidth * 0.45,
            height:this.windowHeight * 0.47,
          })
        }

      },
      /**
       * 获取accessToken
       * @param ppKey,appSecret
       * @returns {Promise<AxiosResponse<any>>}
       */
      getAccessToken(){
        let url = '/api/lapp/token/get?appKey=' + this.appKey + '&appSecret=' + this.secret;
        return axios({
          method: 'post',
          baseURL: process.env.API, // 修改这里
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000

        }).then((response) => {
          // this.player = new EZUIKit.EZUIKitPlayer({
          //   id: 'video-container', // 视频容器ID
          //   accessToken: response.data.accessToken,
          //   url: 'ezopen://open.ys7.com/C78957921/1.live',
          //   template: 'theme',
          // });
          // this.player.play();
          this.accessToken = response.data.accessToken;
        }) .catch((error) => {
          console.log("error",error)
        })
      },

      /**
       * 获取URL
       * @param deviceSerial
       * @returns {Promise<AxiosResponse<any>>}
       */
      getURL(){
        let url = '/api/lapp/v2/live/address/get?accessToken=' + this.accessToken + '&deviceSerial=' + this.defaultDevice + '&channelNo=' + this.channelNo;
        return axios({
          method: 'post',
          baseURL: process.env.API, // 修改这里
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000

        }).then((response) => {
          this.newURL = response.data.url;
        }) .catch((error) => {
          this.newURL = 'ezopen://open.ys7.com/' + this.defaultDevice + '/1.hd.live';
          console.log("error",error);
        })
      },
      /**
       * 切换画面
       */
      changeTab(){
        this.$emit("showMapBar", true);
      },
    }
  }
</script>

<style lang="less" scoped>
  .vedio-box{
    width: 49%;
    height: 47%;
    position:absolute;

    .el-select {
      width: 150px;
      height: 50px;
      margin-right: 3%;
    }

    /deep/ .el-input__inner {
      background-color: #06143a;
      outline: none;
      //border: none;
      border-color: #09CEFF;
      color: #51b9fb;
      appearance: none;
      -webkit-appearance: none;
    }

    .el-tag{
      margin-top: 5px;
      background-color: #06143a;
      border: none;
      font-size: 14px;
      color: #ffffff;
    }
  }

  .img{
    height: 32px;
    width: 32px;
    cursor: pointer;
  }

  .vedio {
    position:relative;
    left:3%;
    margin-top:2%;
    width: 100%;
    height: 100%;
    display: block !important;
  }

  .iframe {
    height: 98%;
    width: 95%;
    display: block !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/centerVedio.vue